import { render, staticRenderFns } from "./DashboardTemplateCasual.vue?vue&type=template&id=9ee2cf20&scoped=true&"
import script from "./DashboardTemplateCasual.vue?vue&type=script&lang=js&"
export * from "./DashboardTemplateCasual.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTemplateCasual.vue?vue&type=style&index=0&id=9ee2cf20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ee2cf20",
  null
  
)

export default component.exports